import { Link, Typography } from '@mui/material';

type MsgFileDownloadProps = {
  downloadLink: string;
  description?: string;
  title?: string;
};
export const MsgFileDownload = (props: MsgFileDownloadProps) => {
  const { downloadLink, title, description } = props;

  const titleWithQuotes = title
    ?.replace('Файл ', 'Файл "')
    .replace(' сформирован', '" сформирован');

  return (
    <div className="msg-container">
      {title && <Typography>{titleWithQuotes}</Typography>}
      <Link
        href={downloadLink}
        target="_blank"
        rel="noreferrer"
      >
        Скачать
      </Link>
    </div>
  );
};
